"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProposalCard = exports.COLLAPSED_CHAT_BODY_MAX_HEIGHT_PX = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lucideReact = require("lucide-react");
var _utils = require("@design/lib/utils");
var _cardKinds = require("./card-kinds");
var _proposalCardCollapsedContext = require("./proposal-card-collapsed-context");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var COLLAPSED_CHAT_BODY_MAX_HEIGHT_PX = exports.COLLAPSED_CHAT_BODY_MAX_HEIGHT_PX = 144;
var TRACKER_CONTENT_MAX_HEIGHT_PX = 48;
var CONTEXT_UNDER_CONTENT = {
  redline: false,
  changeThroughout: false,
  revert: false,
  revertOwn: false,
  table: true,
  tableRows: true,
  tableRowDeletion: true,
  newTable: true,
  paragraph: false,
  comment: true,
  reply: true
};
var FOCUS_VISIBLE_RING_CLASSES = "outline-hidden focus-visible:ring-(length:--component-base-focus-ring-width) focus-visible:ring-ring/50";
var TRACKER_TONE_CLASSES = {
  default: "bg-[#F8F6F3] border-[#E5E2DD] hover:border-border-primary-subtle hover:bg-background-primary-canvas",
  applied: "bg-[#F0F9FF] border-[#B3D9FF] hover:border-[#8CC4F5]",
  dismissed: "bg-[#F5F5F5] border-[#D4D3D0] opacity-70 hover:opacity-90",
  problem: "bg-[#FDF2F4] border-[#E3A3AE]"
};
function activatesOnEnterOrSpace(activate) {
  return function (event) {
    if (event.target !== event.currentTarget) return;
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    activate();
  };
}
function useContentOverflows(isExpanded) {
  var clipRef = (0, _react.useRef)(null);
  var naturalRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    contentOverflows = _useState2[0],
    setContentOverflows = _useState2[1];
  (0, _react.useLayoutEffect)(function () {
    var clip = clipRef.current;
    var natural = naturalRef.current;
    if (clip === null || natural === null || typeof ResizeObserver === "undefined") return;
    var measure = function measure() {
      return setContentOverflows(natural.offsetHeight > clip.clientHeight + 1);
    };
    measure();
    var observer = new ResizeObserver(measure);
    observer.observe(natural);
    observer.observe(clip);
    return function () {
      return observer.disconnect();
    };
  }, [isExpanded]);
  return {
    clipRef: clipRef,
    naturalRef: naturalRef,
    contentOverflows: contentOverflows
  };
}
function useTrackerHeaderOverflowsOneLine() {
  var headerRef = (0, _react.useRef)(null);
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    oneLineWidthPx = _useState4[0],
    setOneLineWidthPx = _useState4[1];
  (0, _react.useLayoutEffect)(function () {
    var header = headerRef.current;
    if (header === null || typeof ResizeObserver === "undefined") return;
    var measure = function measure() {
      if (oneLineWidthPx === null && header.scrollWidth > header.clientWidth + 1) setOneLineWidthPx(header.scrollWidth);
      if (oneLineWidthPx !== null && header.clientWidth >= oneLineWidthPx) setOneLineWidthPx(null);
    };
    measure();
    var observer = new ResizeObserver(measure);
    observer.observe(header);
    return function () {
      return observer.disconnect();
    };
  }, [oneLineWidthPx]);
  return {
    headerRef: headerRef,
    headerOverflowsOneLine: oneLineWidthPx !== null
  };
}
var TrackerHeaderControls = function TrackerHeaderControls(_ref) {
  var controls = _ref.controls,
    onTheirOwnLine = _ref.onTheirOwnLine;
  if (onTheirOwnLine) return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: "flex basis-full items-center justify-end gap-2",
    children: controls
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "flex-1"
    }), controls]
  });
};
var ProposalCard = exports.ProposalCard = function ProposalCard(_ref2) {
  var identity = _ref2.identity,
    density = _ref2.density,
    tone = _ref2.tone,
    controls = _ref2.controls,
    content = _ref2.content,
    context = _ref2.context,
    _ref2$comments = _ref2.comments,
    comments = _ref2$comments === void 0 ? null : _ref2$comments,
    _ref2$collapsedSummar = _ref2.collapsedSummary,
    collapsedSummary = _ref2$collapsedSummar === void 0 ? null : _ref2$collapsedSummar,
    leading = _ref2.leading,
    status = _ref2.status,
    onOpen = _ref2.onOpen,
    _ref2$expanded = _ref2.expanded,
    expanded = _ref2$expanded === void 0 ? false : _ref2$expanded;
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isExpandedByUser = _useState6[0],
    setIsExpandedByUser = _useState6[1];
  var isExpanded = expanded || isExpandedByUser;
  var setIsExpanded = setIsExpandedByUser;
  var _useContentOverflows = useContentOverflows(isExpanded),
    clipRef = _useContentOverflows.clipRef,
    naturalRef = _useContentOverflows.naturalRef,
    contentOverflows = _useContentOverflows.contentOverflows;
  var _useTrackerHeaderOver = useTrackerHeaderOverflowsOneLine(),
    headerRef = _useTrackerHeaderOver.headerRef,
    headerOverflowsOneLine = _useTrackerHeaderOver.headerOverflowsOneLine;
  var contextUnderContent = CONTEXT_UNDER_CONTENT[identity.kind];
  var contextBlock = context === null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex-shrink-0",
    children: context
  });
  var contextAbove = contextUnderContent ? null : contextBlock;
  var contextBelow = contextUnderContent ? contextBlock : null;
  if (density === "tracker") {
    var trackerContent = content === null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "overflow-hidden",
      style: {
        maxHeight: TRACKER_CONTENT_MAX_HEIGHT_PX
      },
      children: content
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      role: "button",
      tabIndex: 0,
      onClick: onOpen,
      onKeyDown: activatesOnEnterOrSpace(function () {
        return onOpen === null || onOpen === void 0 ? void 0 : onOpen();
      }),
      title: "Show this card in the chat",
      "data-proposal-card": identity.kind,
      className: (0, _utils.cn)("flex flex-col gap-1 px-2 py-1.5 rounded border cursor-pointer transition-colors", FOCUS_VISIBLE_RING_CLASSES, TRACKER_TONE_CLASSES[tone]),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        ref: headerRef,
        className: (0, _utils.cn)("flex items-center gap-2 text-xs", headerOverflowsOneLine && "flex-wrap gap-y-1"),
        children: [leading, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "font-semibold text-[#4a5568]",
          children: identity.cardNumber === undefined ? "" : "#".concat(identity.cardNumber)
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "text-[#686766]",
          children: _cardKinds.PROPOSAL_CARD_KIND_LABELS[identity.kind]
        }), status, /*#__PURE__*/(0, _jsxRuntime.jsx)(TrackerHeaderControls, {
          controls: controls,
          onTheirOwnLine: headerOverflowsOneLine
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "pl-6 flex flex-col gap-0.5 text-[11px] leading-[16px] text-[#4a5568]",
        children: [contextAbove, trackerContent, contextBelow]
      })]
    });
  }
  var fade = !isExpanded && contentOverflows ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    "aria-hidden": "true",
    className: "absolute bottom-0 left-0 right-0 h-6 pointer-events-none bg-gradient-to-b from-transparent to-white"
  }) : null;
  function renderBodyOpenedByClick() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      role: "button",
      tabIndex: 0,
      "aria-expanded": isExpanded,
      onClick: function onClick(event) {
        var _window$getSelection$, _window$getSelection;
        if (((_window$getSelection$ = (_window$getSelection = window.getSelection()) === null || _window$getSelection === void 0 ? void 0 : _window$getSelection.toString()) !== null && _window$getSelection$ !== void 0 ? _window$getSelection$ : "").length > 0) return;
        event.stopPropagation();
        setIsExpanded(!isExpanded);
      },
      onKeyDown: activatesOnEnterOrSpace(function () {
        return setIsExpanded(!isExpanded);
      }),
      className: (0, _utils.cn)(CHAT_BODY_CLASSES, FOCUS_VISIBLE_RING_CLASSES, !isExpanded && "hover:bg-[#F8F9FA]"),
      "data-sentry-component": "renderBodyOpenedByClick",
      "data-sentry-source-file": "ProposalCard.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        "data-proposal-card-change": true,
        className: "flex min-h-0 flex-col gap-1",
        style: isExpanded ? undefined : {
          maxHeight: COLLAPSED_CHAT_BODY_MAX_HEIGHT_PX
        },
        children: [contextAbove, /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          ref: clipRef,
          className: (0, _utils.cn)("relative min-h-0", !isExpanded && "overflow-hidden"),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            ref: naturalRef,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_proposalCardCollapsedContext.ProposalCardCollapsedContext.Provider, {
              value: !isExpanded,
              "data-sentry-element": "ProposalCardCollapsedContext.Provider",
              "data-sentry-source-file": "ProposalCard.tsx",
              children: content
            })
          }), fade]
        }), contextBelow]
      }), comments]
    });
  }
  function renderBodyOpenedBySummary(summary) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: CHAT_BODY_CLASSES,
      "data-sentry-component": "renderBodyOpenedBySummary",
      "data-sentry-source-file": "ProposalCard.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        type: "button",
        "aria-expanded": isExpanded,
        "aria-label": summaryToggleLabelOf(isExpanded),
        onClick: function onClick(event) {
          event.stopPropagation();
          setIsExpanded(!isExpanded);
        },
        className: (0, _utils.cn)("flex items-start gap-1 w-full bg-transparent border-none p-0 text-left cursor-pointer rounded", FOCUS_VISIBLE_RING_CLASSES),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SummaryChevron, {
          isExpanded: isExpanded,
          "data-sentry-element": "SummaryChevron",
          "data-sentry-source-file": "ProposalCard.tsx"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "min-w-0 flex-1",
          children: summary
        })]
      }), content, isExpanded && contextBlock, comments]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-proposal-card": identity.kind,
    className: (0, _utils.cn)("box-border flex flex-col w-[90%]", tone === "dismissed" && "opacity-70"),
    "data-sentry-component": "ProposalCard",
    "data-sentry-source-file": "ProposalCard.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex-shrink-0 text-[14px] font-semibold mb-1",
      children: (0, _cardKinds.proposalCardTitleOf)(identity.cardNumber, identity.kind)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex-shrink-0",
      children: controls
    }), collapsedSummary === null ? renderBodyOpenedByClick() : renderBodyOpenedBySummary(collapsedSummary)]
  });
};
var CHAT_BODY_CLASSES = "relative w-full box-border flex flex-col gap-1 bg-white border border-[#D4D3D0] rounded px-3 py-2 text-[14px] leading-[1.5] text-[#171715]";
function summaryToggleLabelOf(isExpanded) {
  if (isExpanded) return "Hide the places";
  return "Show the places";
}
var SummaryChevron = function SummaryChevron(_ref3) {
  var isExpanded = _ref3.isExpanded;
  if (isExpanded) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.ChevronDown, {
    size: 14,
    "aria-hidden": "true",
    className: "flex-shrink-0 mt-[1px] text-[#686766]"
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.ChevronRight, {
    size: 14,
    "aria-hidden": "true",
    className: "flex-shrink-0 mt-[1px] text-[#686766]",
    "data-sentry-element": "ChevronRight",
    "data-sentry-component": "SummaryChevron",
    "data-sentry-source-file": "ProposalCard.tsx"
  });
};